import * as React from 'react';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelNavigator from 'UIComponents/panel/UIPanelNavigator';
import WebhookDefinitionEditPanelContents from 'automation-ui-enrollment/components/eventEnrollment/WebhookDefinitionEditPanelContents';
import WebhookPropertyEditPanelContents from 'automation-ui-enrollment/components/eventEnrollment/WebhookPropertyEditPanelContents';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EDIT_WEBHOOK_PANEL_WIDTH = 550;
const getPanelKeyForPropertyEditIndex = propertyEditIndex => {
  return propertyEditIndex !== null ? 'EDIT_PROPERTY' : 'EDIT_EVENT';
};
const WebhookEditPanel = ({
  objectTypeId,
  webhookDefinition,
  handleWebhookUpdate,
  onClose
}) => {
  const [stagedWebhookDefinition, setStagedWebhookDefinition] = React.useState(webhookDefinition);
  const [propertyEditIndex, setPropertyEditIndex] = React.useState(null);
  const trackEvent = useTrackEvent();
  return /*#__PURE__*/_jsxs(UIPanelNavigator, {
    currentPanel: getPanelKeyForPropertyEditIndex(propertyEditIndex),
    onPreviousClick: () => setPropertyEditIndex(null),
    children: [/*#__PURE__*/_jsx(UIPanel, {
      width: EDIT_WEBHOOK_PANEL_WIDTH,
      panelKey: "EDIT_EVENT",
      children: /*#__PURE__*/_jsx(WebhookDefinitionEditPanelContents, {
        webhookDefinition: webhookDefinition,
        stagedWebhookDefinition: stagedWebhookDefinition,
        setStagedWebhookDefinition: setStagedWebhookDefinition,
        setPropertyEditIndex: setPropertyEditIndex,
        onSave: () => {
          trackEvent(Trackables.WEBHOOK_TRIGGER_MODIFIED, {
            editType: 'EDIT_CONFIRM',
            objectTypeId
          });
          handleWebhookUpdate(stagedWebhookDefinition);
          onClose();
        },
        onClose: onClose
      })
    }), /*#__PURE__*/_jsx(UIPanel, {
      width: EDIT_WEBHOOK_PANEL_WIDTH,
      panelKey: "EDIT_PROPERTY",
      children: /*#__PURE__*/_jsx(WebhookPropertyEditPanelContents, {
        propertyEditIndex: propertyEditIndex,
        stagedWebhookDefinition: stagedWebhookDefinition,
        setStagedWebhookDefinition: setStagedWebhookDefinition,
        onClose: () => setPropertyEditIndex(null)
      })
    })]
  });
};
export default WebhookEditPanel;